import { useEffect, useRef, useState } from "react";
import { MemberMediaProps } from "../../../typings/memberMedia";
import ToolBarActions from './ToolBarActions';
import TextareaAutosize from 'react-textarea-autosize';
import { getConverstaionList } from "../../../services/messageService";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { setConversation } from "../../../redux/carpet";

export interface ToolBarProps {
    sent: (message: string) => void;
    sendLocation: () => void;
    sendImage: (image: any) => void;
    sendProfileImages: (images: any) => void;
    openBreakTheIceQuestion: () => void;
    profileImages: MemberMediaProps[];
}

const ToolBar = ({ openBreakTheIceQuestion, sendProfileImages, sent, sendLocation, sendImage, profileImages }: ToolBarProps) => {

    const dispatch = useDispatch();
    const myMemberCode = useSelector((state: RootState) => state.member.memberCode);
    const [input, setInput] = useState<string>('');
    const [disableSendButton, setDisableSendButton] = useState<boolean>(true);
    const inputRef = useRef<any>(null);
    // useEffect(() => {
    //     window.Webflow.ready();
    // }, [])

    const onPress = async () => {
        const finalText = input.trim().replace(/^\s*$(?:\r\n?|\n)/gm, '');
        if (finalText.length > 0) {
            sent(finalText);
            setInput('');
            setDisableSendButton(true);
            inputRef.current.focus();
            const { data } = await getConverstaionList(myMemberCode);
            dispatch(setConversation(data));
        }
    };

    const onChangeText = (text: string) => {
        const fixedText = text.trim().replace(/^\s*$(?:\r\n?|\n)/gm, '');
        if (fixedText && fixedText.length > 0) {
            setDisableSendButton(false);
            setInput(text);
        }
        else {
            setDisableSendButton(true);
            setInput('');
        }
    };

    const toolBarActionsProps = {
        profileImages,
        sendLocation,
        sentImageMessage: sendImage,
        sentProfileImages: sendProfileImages,
        openBreakTheIceQuestion
    }

    return (

        <>
            <div className="chat_insert w-form">
                <form>
                    <div className="chat_insert_group">
                        <TextareaAutosize ref={(inputRef)} value={input} onChange={e => onChangeText(e.target.value)} autoComplete="off" maxRows={5} className="chat_txt_insert w-input" />

                        {/* <input autoComplete="off" type="text" ref={inputRef} name="messageInput" value={input} onChange={e => onChangeText(e.target.value)} autoComplete="off" maxLength={256} className="chat_txt_insert w-input" /> */}
                        <input autoComplete="off" type="button" disabled={disableSendButton} onClick={onPress} data-wait className="chat_insert_but w-button" />
                    </div>
                </form>
            </div>
            <ToolBarActions {...toolBarActionsProps}
            />
        </>
    )

}

export default ToolBar;